import React from "react";
import { Card, Col } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { NumberOfBadge } from "../../../../Constant";
import { NUMBER_CONTEXT, NUMBER_DATA } from "../../../../Data/UiKit/BadgesContextualVariations";
import CommomTagAndPillsCardBody from "../Common/CommomTagAndPillsCardBody";

const NumberofBadgeCard = () => {
  return (
    <Col sm="12" xl="6">
      <Card>
        <CommonCardHeader title={NumberOfBadge} span={NUMBER_DATA} />
        <CommomTagAndPillsCardBody number={NUMBER_CONTEXT} />
      </Card>
    </Col>
  );
};

export default NumberofBadgeCard;
